module.exports = __webpack_public_path__ + "assets/Track-Spotify.cf808fd3.svg";